<template>
  <div class="gs-funnel-draft-notice">
    <p>Not published. Customer and affiliate access is unavailable.</p>
    <button type="button" @click="$emit('publish')" :title="explanation" v-tooltip="explanation">
      Make this funnel live <span aria-hidden="true">→</span>
    </button>
  </div>
</template>
<script>
export default {
  name: 'FunnelDraftNotice',
  data: () => ({ explanation: 'While this funnel is not live, affiliate links, checkouts and affiliate portals are unavailable, and it cannot appear in the marketplace. Open Availability & discovery, turn on Make this funnel live, then save.' }),
};
</script>
<style scoped>
.gs-funnel-draft-notice { padding:12px; margin:10px 0 14px; border:1px solid #E6C5AA; border-radius:8px; background:#FFF9F0; color:#704632; }
.gs-funnel-draft-notice p { margin:0; font-size:12px; line-height:1.55; }
.gs-funnel-draft-notice button { display:block; margin-top:8px; padding:5px 0; border:0; background:transparent; color:#A92E28; font:inherit; font-size:12px; font-weight:750; cursor:pointer; text-align:left; }
.gs-funnel-draft-notice button:focus-visible { outline:2px solid #A92E28; outline-offset:4px; }
</style>
